import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { PackagesRoute } from 'routes/wallet.routes';
import useProfileStore from 'store/profile';
import {
  infoExistInStorage,
  setExpirationIdsInLocalStorage,
} from 'utils/permission.util';

type UseExpireActionSheetType = {
  openActionSheetStatus: boolean;
  setOpenActionSheetStatus: (value?: boolean) => void;
  handleCloseActionSheet: (value?: boolean) => void;
};

const useExpireActionSheet = (): UseExpireActionSheetType => {
  const router = useRouter();
  const [openActionSheetStatus, setOpenActionSheetStatus] = useState(false);
  const expirePackages =
    useProfileStore((state) => state.purchasedPackageData?.expirePackages) ||
    {};

  useEffect(() => {
    setOpenActionSheetStatus(
      expirePackages.info &&
        !infoExistInStorage(expirePackages.info?.ids, expirePackages.type),
    );
  }, [expirePackages]);

  const handleCloseActionSheet = (redirect = false): void => {
    setOpenActionSheetStatus(false);
    setExpirationIdsInLocalStorage(expirePackages);
    if (redirect) router.replace(PackagesRoute());
    else router.back();
  };

  return {
    openActionSheetStatus,
    setOpenActionSheetStatus,
    handleCloseActionSheet,
  };
};

export default useExpireActionSheet;
